import Vue from 'vue'
import axios from 'axios'
import md5 from 'js-md5'
import qs from 'qs'
import CryptoJS from 'crypto-js'
import {router} from '@/router'
import store from '@/store'
import { Message, Loading } from 'element-ui'
import { getToken, removeToken, isManualLogout } from '@/utils/auth'

let loader
let authRedirecting = false
// let theUrl = api_url

const service = axios.create({
    baseURL: api_url,
    timeout: 30000,   // 设置请求超时
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    transformRequest: (data) => {
        return qs.stringify(data)
    }
})
const version = '1.0.1'
const signKey = focus[47]
const encrypt = 2
const device = 'pcweb'
let token = ''

// 请求拦截器
service.interceptors.request.use( async (config) => {
        if(config.isShowLoading) {
            loader = Loading.service({
                lock: true,
                text: '请稍后...',
                spinner: 'el-icon-loading',  // 自定义图标
                background: 'rgba(0, 0, 0, 0.2)',
                customClass: 'load-page'
            })
        }
        token = await getToken() || ''
        let xid = window.xid
        
        const time = Date.parse(new Date()) / 1000
        const custom = Math.random().toString(36).substr(2)
        const c = config.url
        let url = ''
        if (c.search('&') !== -1) {
            url = c.substring(0, c.indexOf('&'))
        } else {
            url = c
        }
        let str = xid + signKey + url.toLowerCase() + time + device + version + token + custom
        let sign = md5(str)
        config.headers = {
            ...config.headers,
            xid,
            version,
            device,
            token,
            encrypt,
            custom,
            sign,
            time
        }
        return config
    },
    error => {
        if(loader) {
            loader.close()
        }
        return Promise.reject(error)
    }
)
// 响应拦截器
service.interceptors.response.use(
    response => {
        if(loader) {
            loader.close()
        }
        const res = response.data
        const iv = CryptoJS.enc.Hex.parse(md5('key_' + res.time))
        const option = { iv: iv, padding: CryptoJS.pad.ZeroPadding }
        // 部分接口会保留 encrypt=1，但 data 已经是解密后的对象或数组。
        // 只有字符串数据才继续执行 AES 解密，避免把明文数组当密文处理。
        if (res.encrypt === 1 && res.data && typeof res.data === 'string') {
            let newKey = md5(res.sign)
            let key = CryptoJS.enc.Hex.parse(newKey)
            let decrypted = CryptoJS.AES.decrypt(res.data, key, option)
            let string = decrypted.toString(CryptoJS.enc.Utf8)
            try {
                res.data = JSON.parse(string)
            } catch (e) {
                res.data = string
            }
            return res
        } else {
            if(res.code == 401) {
                res.isAuthError = true
                const manualLogout = isManualLogout()
                removeToken()
                const shouldNotify = !manualLogout && !authRedirecting && router.currentRoute.path !== '/login'
                if (shouldNotify) {
                    Message({
                        message: '请登录后操作！',
                        type: 'error',
                        duration: 3 * 1000
                    })
                }
				store.dispatch('user/logout')
                if (!manualLogout && !authRedirecting && router.currentRoute.path !== '/login') {
                    authRedirecting = true
                    setTimeout(() => {
                        router.push(`/login`).finally(() => {
                            authRedirecting = false
                        })
                    }, 500);
                }
                return Promise.reject(res)
            }
            if (response.config.rawResponse) {
                return res
            }
            if(res.code == 0) {
                Message({
                    message: res.msg,
                    type: 'error',
                    duration: 3 * 1000
                })
                return Promise.reject(res)
            } else {
                return res
            }
        }
    },
    error => {
        return Promise.reject(error)
    }
)
export { service }
export default service

